import { IoIosAlbums } from "react-icons/io";
import { RiCheckboxCircleLine } from "react-icons/ri";
import { MdForum } from "react-icons/md";
import { FaFaceGrinBeam } from "react-icons/fa6";

const TYPES = [
  {
    id: "mood",
    label: "Mood capture",
    description: "How are you feeling?",
    icon: FaFaceGrinBeam,
  },
  {
    id: "single",
    label: "Single choice",
    description: "One selectable answer",
    icon: IoIosAlbums,
  },
  {
    id: "multi",
    label: "Multiple choice",
    description: "Multiple selectable answers",
    icon: RiCheckboxCircleLine,
  },
  {
    id: "text",
    label: "Text answer",
    description: "Free text response",
    icon: MdForum,
  },
];

const QuestionTypeSelector = ({ value, onChange }) => {
  return (
    <div className="flex flex-wrap gap-2">
      {TYPES.map((type) => {
        const Icon = type.icon;
        const active = value === type.id;

        return (
          <button
            key={type.id}
            type="button"
            onClick={() => onChange(type.id)}
            className={`flex items-center gap-3 px-4 py-3 rounded-xl border transition text-left
              ${
                active
                  ? "bg-mpPurple text-white border-mpPurple shadow-sm"
                  : "bg-white text-slate-700 border-slate-200 hover:bg-slate-50"
              }`}
          >
            <Icon
              fontSize="small"
              className={active ? "text-white" : "text-slate-500"}
            />

            <div className="flex flex-col">
              <span className="text-sm font-semibold">{type.label}</span>
              <span
                className={`text-xs ${
                  active ? "text-white/80" : "text-slate-400"
                }`}
              >
                {type.description}
              </span>
            </div>
          </button>
        );
      })}
    </div>
  );
};

export default QuestionTypeSelector;
